import validate from "/home/node/app/node_modules/.pnpm/nuxt@3.13.0_@parcel+watcher@2.4.1_@types+node@22.5.2_eslint@8.57.0_ioredis@5.4.1_magicast@0.3_jq7chgbtrfqzbn3jqh4wcsidti/node_modules/nuxt/dist/pages/runtime/validate.js";
import blocked_45global from "/home/node/app/frontend/middleware/blocked.global.js";
import manifest_45route_45rule from "/home/node/app/node_modules/.pnpm/nuxt@3.13.0_@parcel+watcher@2.4.1_@types+node@22.5.2_eslint@8.57.0_ioredis@5.4.1_magicast@0.3_jq7chgbtrfqzbn3jqh4wcsidti/node_modules/nuxt/dist/app/middleware/manifest-route-rule.js";
export const globalMiddleware = [
  validate,
  blocked_45global,
  manifest_45route_45rule
]
export const namedMiddleware = {}